import service from './service';
import { UrlBuilder } from './url-builder';

export const list = async (recordDate, page, pageSize) => {
  const response = await service.get(
    `/logbooks/all/entries?recordDate=${recordDate}&page=${page}&pageSize=${pageSize}`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listByCompany = async (companyId, filter, page, pageSize) => {
  if (!companyId) return [];
  const response = await service.get(
    `/timesheets/${companyId}/entries?fromDate=${filter.fromDate}&toDate=${filter.toDate}&page=${page}&pageSize=${pageSize}`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listTimesheet = async (page, pageSize) => {
  const response = await service.get(
    `users/self/timesheets/all/entries?page=${page}&pageSize=${pageSize}`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listTimesheetGuest = async (page, pageSize, companyId) => {
  const response = await service.get(
    `users/self/timesheets/all/entries?page=${page}&pageSize=${pageSize}&companyId=${companyId} `
  );
  // const response = await service.get(
  //   `users/self/timesheets/all/entries?page=${page}&pageSize=${pageSize}&visitor=true`
  // );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listTimesheetForReport = async () => {
  const response = await service.get(`users/self/timesheets/all/entries?mode=ALL`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listTimesheetGuestForReport = async (companyId) => {
  // const response = await service.get(`users/self/timesheets/all/entries?visitor=true&mode=ALL`);
  const response = await service.get(
    `users/self/timesheets/all/entries?companyId=${companyId}&mode=ALL`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listTimesheetForAdmin = async (page, pageSize, companyFilter) => {
  const builder = new UrlBuilder(`/admin/timesheets`);

  builder.add('page', page);
  builder.add('pageSize', pageSize);
  builder.add('companyId', companyFilter);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

export const listTimesheetForAdminReport = async (companyFilter) => {
  const builder = new UrlBuilder(`/admin/timesheets`);
  builder.add('companyId', companyFilter);
  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

export const listTimesheetForPartner = async (partnerId, page, pageSize, companyFilter) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/timesheets`);

  builder.add('page', page);
  builder.add('pageSize', pageSize);
  builder.add('companyId', companyFilter);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

export const listTimesheetForPartnerReport = async (partnerId, companyFilter, mode) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/timesheets`);

  builder.add('mode', mode);
  builder.add('companyId', companyFilter);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

export const managerlistTimesheet = async (premiseId, page, pageSize) => {
  const response = await service.get(
    `manager/timesheets/premise/${premiseId}?page=${page}&pageSize=${pageSize}`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

// export const listByCompany = async (companyId, filter, page, pageSize) => {
//   if (!companyId) return [];
//   const response = await service.get(
//     `/users/self/timesheets/${companyId}/entries?fromDate=${filter.fromDate}&toDate=${filter.toDate}&page=${page}&pageSize=${pageSize}`
//   );

//   if (response.status === 200) {
//     const data = response.data;

//     return data;
//   }
//   return [];
// };

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  list,
  listByCompany,
  listTimesheet,
  listTimesheetForAdmin,
  listTimesheetForPartner,
  listTimesheetForReport,
  listTimesheetForAdminReport,
  listTimesheetGuestForReport,
  listTimesheetGuest,
  listTimesheetForPartnerReport,
};
